import { render, staticRenderFns } from "./stainlessSteelCarving.vue?vue&type=template&id=96ba3cf6&scoped=true"
import script from "./stainlessSteelCarving.vue?vue&type=script&lang=js"
export * from "./stainlessSteelCarving.vue?vue&type=script&lang=js"
import style0 from "./stainlessSteelCarving.vue?vue&type=style&index=0&id=96ba3cf6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96ba3cf6",
  null
  
)

export default component.exports